<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import '../src/assets/css/font.css'
export default {
  name: 'App',
  created() {

    if ((navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {

    } else {
      console.log('pc')
      window.location.href = "https://westgenepharma.com";  //跳转到电脑
    }
  }
}
</script>

<style>
body {
  font-family: "思源黑体", "Microsoft YaHei";
  /* font-family: Source Han Sans CN; */
  /* font-family:"微软雅黑"; */
  padding: 0;
  margin: 0;

}
</style>



// WEBPACK FOOTER //
// src/App.vue